'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmptyState({
  translationKey,
  hasRevenueAttributionLimitedAccess
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "empty-state",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "end",
    style: {
      height: '100%',
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts"
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockStart: "400",
      marginBlockEnd: hasRevenueAttributionLimitedAccess ? '0' : undefined,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `components.revenueAttributionCard.emptyState.${translationKey}`
      })
    }), hasRevenueAttributionLimitedAccess && /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "components.revenueAttributionCard.emptyState.upgrade"
      })
    })]
  });
}
EmptyState.propTypes = {
  translationKey: PropTypes.string.isRequired,
  hasRevenueAttributionLimitedAccess: PropTypes.bool
};